import { createSlice } from "@reduxjs/toolkit";

import {
  getRoleThunk,
  createRoleThunk,
  updateRoleThunk,
  deleteRoleThunk,
  addPermissionThunk,
} from "state/action/role";

// Initial state
const initialState = {
  // Get Role inisial state
  getRole: {
    data: null,
    isFulfilled: false,
    isPending: false,
    isRejected: false,
    err: null,
  },
  // Create Role inisial state
  createRole: {
    data: null,
    isFulfilled: false,
    isPending: false,
    isRejected: false,
    err: null,
  },
  // Create Role inisial state
  addPermission: {
    data: null,
    isFulfilled: false,
    isPending: false,
    isRejected: false,
    err: null,
  },
  // Update Role inisial state
  updateRole: {
    data: null,
    isFulfilled: false,
    isPending: false,
    isRejected: false,
    err: null,
  },
  // Delete Role inisial state
  deleteRole: {
    data: null,
    isFulfilled: false,
    isPending: false,
    isRejected: false,
    err: null,
  },

  selectedRole: {},
  // Role object value
  role_object_value: "",
  // RolePage UI state (search/filters, dialogs, selection, toast)
  ui: {
    loading: false,
    search: "",
    includeInactive: false,
    includeSystem: true,
    selected: null,
    stats: null,
    createOpen: false,
    editOpen: false,
    cloneOpen: false,
    deleteConfirm: null,
    snack: { open: false, msg: "", severity: "success" },
    inspectorOpen: false,
  },
  // RoleFormDialog draft state (flat permission IDs, unlike createRoleInputBody)
  roleFormState: {
    name: "",
    code: "",
    description: "",
    permissions: [],
  },
  // CloneDialog draft state
  cloneFormState: {
    name: "",
    code: "",
    loading: false,
  },
};

export const roleSlice = createSlice({
  name: "role",
  initialState,
  reducers: {
    setSelectedRole: (state, action) => {
      return {
        ...state,
        selectedRole: action.payload,
      };
    },
    // Partial update of RolePage UI state, e.g. dispatch(setRoleUi({ search: "x" }))
    setRoleUi: (state, action) => {
      Object.assign(state.ui, action.payload);
    },
    resetRoleUi: (state) => {
      state.ui = initialState.ui;
    },
    setRoleFormState: (state, action) => {
      Object.assign(state.roleFormState, action.payload);
    },
    resetRoleFormState: (state) => {
      state.roleFormState = initialState.roleFormState;
    },
    setCloneFormState: (state, action) => {
      Object.assign(state.cloneFormState, action.payload);
    },
    resetCloneFormState: (state) => {
      state.cloneFormState = initialState.cloneFormState;
    },

    setClearCreateRole: (state, _) => {
      return {
        ...state,
        createRole: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
      };
    },

    setClearUpdateRole: (state, _) => {
      return {
        ...state,
        updateRole: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
      };
    },
    setClearDeleteRole: (state, _) => {
      return {
        ...state,
        deleteRole: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
      };
    },
    setClearAllRoleState: (state, _) => {
      return {
        ...state,
        // Get Role inisial state
        getRole: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
        // Create Role inisial state
        createRole: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
        // Update Role inisial state
        updateRole: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
        // Delete Role inisial state
        deleteRole: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
        // Role object value
        role_object_value: "",
      };
    },
  },
  extraReducers(builder) {
    builder
      // Get Role reducer
      .addCase(getRoleThunk.pending, (state, _) => {
        return {
          ...state,
          getRole: {
            data: null,
            isPending: true,
            isFulfilled: false,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(getRoleThunk.fulfilled, (state, action) => {
        return {
          ...state,
          getRole: {
            data: action.payload,
            isPending: false,
            isFulfilled: true,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(getRoleThunk.rejected, (state, action) => {
        return {
          ...state,
          getRole: {
            data: null,
            isPending: false,
            isFulfilled: false,
            isRejected: true,
            err: action.error.message,
          },
        };
      })
      // Create Role reducer
      .addCase(createRoleThunk.pending, (state, _) => {
        return {
          ...state,
          createRole: {
            data: null,
            isPending: true,
            isFulfilled: false,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(createRoleThunk.fulfilled, (state, action) => {
        return {
          ...state,
          createRole: {
            data: action.payload,
            isPending: false,
            isFulfilled: true,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(createRoleThunk.rejected, (state, action) => {
        return {
          ...state,
          createRole: {
            data: null,
            isPending: false,
            isFulfilled: false,
            isRejected: true,
            err: action.error.message,
          },
        };
      })
      // Add Permission reducer
      .addCase(addPermissionThunk.pending, (state, _) => {
        return {
          ...state,
          addPermission: {
            data: null,
            isPending: true,
            isFulfilled: false,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(addPermissionThunk.fulfilled, (state, action) => {
        return {
          ...state,
          addPermission: {
            data: action.payload,
            isPending: false,
            isFulfilled: true,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(addPermissionThunk.rejected, (state, action) => {
        return {
          ...state,
          addPermission: {
            data: null,
            isPending: false,
            isFulfilled: false,
            isRejected: true,
            err: action.error.message,
          },
        };
      })
      // update Role reducer
      .addCase(updateRoleThunk.pending, (state, _) => {
        return {
          ...state,
          updateRole: {
            data: null,
            isPending: true,
            isFulfilled: false,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(updateRoleThunk.fulfilled, (state, action) => {
        return {
          ...state,
          updateRole: {
            data: action.payload,
            isPending: false,
            isFulfilled: true,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(updateRoleThunk.rejected, (state, action) => {
        return {
          ...state,
          updateRole: {
            data: null,
            isPending: false,
            isFulfilled: false,
            isRejected: true,
            err: action.error.message,
          },
        };
      });
  },
});

export const roleAction = {
  ...roleSlice.actions,
  getRoleThunk,
  createRoleThunk,
  updateRoleThunk,
  deleteRoleThunk,
  addPermissionThunk,
};

export function selectRoleObjectValue(state) {
  return state?.role?.role_object_value;
}

export function selectRole(state) {
  return state?.role;
}

export function selectRoleUi(state) {
  return state?.role?.ui;
}

export function selectRoleFormState(state) {
  return state?.role?.roleFormState;
}

export function selectCloneFormState(state) {
  return state?.role?.cloneFormState;
}

export default roleSlice.reducer;
